import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';

const Founders = () => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const fadeIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(20px)',
  });
  return (
    <animated.section style={fadeIn} className="Founders" ref={ref}>
      <h2>Meet the Team</h2>
      <p>Our team is composed of experienced professionals in the field of SEO and AI.</p>
      <p>coming soon</p>
      </animated.section>
  );
}

export default Founders;
